import React, { createContext, useEffect, useState } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { getTokenHeader } from '../../helpers/connection';

export const EchoContext = createContext(null);

export const EchoProvider = ({ children }) => {
  const [echo, setEcho] = useState(null);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      Pusher.logToConsole = true;
    }

    const options = {
      broadcaster: 'pusher',
      key: process.env.REACT_APP_PUSHER_KEY,
      cluster: process.env.REACT_APP_PUSHER_CLUSTER,
      forceTLS: true,
      authEndpoint: process.env.REACT_APP_PUSHER_AUTH_ENDPOINT,
      auth: {
        headers: {
          ...getTokenHeader(),
          accept: 'application/json'
        }
      }
    };

    const echoInstance = new Echo(options);

    setEcho(echoInstance);

    return () => {
      if (echoInstance) {
        echoInstance.disconnect();
      }
    };
  }, []);

  return <EchoContext.Provider value={echo}>{children}</EchoContext.Provider>;
};
